import React, { useEffect, useState } from 'react';
import '../../assets/css/Tips.css'
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import InnerHeaderContent from '../../Components/Header/InnerHeaderContent';
import tipOne from '../../assets/images/tip1.png';
import tipTwo from '../../assets/images/tip2.png';
import tipThree from '../../assets/images/tip3.png';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { TipsByPagination, GetAllFreeTips, GetAllPrimumTipsApi } from '../../Redux/Auth/Auth_Action';
import { ShowPremiumTips } from '../../Redux/services/Apis';
import { toast } from 'react-toastify';

const Tips = () => {
    let navigate = useNavigate();
    const selector = useSelector((state) => state?.Auth?.user);
    const ReduxToken = useSelector((state) => state?.Auth?.token);
    const ReduxPackage = useSelector((state) => state?.Auth?.activePackage);

    const [tips, setTips] = useState(undefined);
    const dispatch = useDispatch();
    const [tipsData, setTipsData] = useState({ tips: [] });

    // console.log(tipsData.tips);

    const TipsOption = (e) => {
        if (e === undefined) {
            // console.log("free tips if working");
            setTips("free_tips");
            dispatch(GetAllFreeTips())
                .then((res) => {
                    // console.log('res from tips page', res.data);
                    setTipsData({ ...tipsData, tips: res.data.response.data });
                })
                .catch((e) => {
                    // console.log('error from tips page', e);
                    toast.error("Network Error");
                })
        }
        else if (e === "free_tips") {
            // console.log("free tips if working");
            setTips("free_tips");
            dispatch(GetAllFreeTips())
                .then((res) => {
                    // console.log('res from tips page', res);
                    setTipsData({ ...tipsData, tips: res.data.response.data });
                })
                .catch((e) => {
                    // console.log('error from tips page', e);
                    toast.error("Network Error");
                })
        } else if (e === "premium_tips") {
            if (ReduxPackage) {
                setTips("premium_tips");
                dispatch(GetAllPrimumTipsApi(ReduxToken))
                    .then((res) => {
                        // console.log('response from tips pagination', res);
                        setTipsData({ ...tipsData, tips: res.data.response.data });
                    }).catch((e) => {
                        // console.log(e, "error from pagination")
                        toast.error("Network Error");
                    })
            } else {
                navigate('/packages');
                toast.error("Subscribe to our package to view premium tips")
            }

        }
    }
    // console.log("tips from tips page", Math.ceil(tipsData?.tips?.total / tipsData?.tips?.per_page));
    useEffect(() => {
        TipsOption();
    }, []);

    useEffect(() => {
        window.scroll(0, 0);
    })

    const TipsPagination = (e) => {

        dispatch(TipsByPagination(e))
            .then((res) => {
                // console.log('response from podcastpagination', res);
                setTipsData({ ...tipsData, tips: res?.data?.response?.data });
            }).catch((e) => {
                // console.log(e, "error from podastpagination");
                toast.error("Network Error");
            })
    };

    // console.log('tips data from tips page',tipsData)

    return (
        <div className='tips_page'>
            <section className='reamining_header_background pos-rel'>
                <Header />
                <InnerHeaderContent pageName={"TIPS"} />
            </section>
            <section className='tips_page_bg'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-mon-reg f-30 lh-01 mb-0 txt-captl'>The Dig’s Free Play Of The Day</p>
                            <p className='f-mon-bold f-50 txt-captl'>Here’s a bone,   <span className='clr-e0'>ON US!</span> </p>
                            <div className='border-btm-pink-secondsec'></div>
                            <p className='wdth-80-per text-white f-mon-light f-20 mt-4'>
                                Get some exclusive sports betting tips online here with all of you so that you guys can get the ball rolling. For exclusive tips you will need to buy a package to get the corresponding tips.
                            </p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12 mt-5 text-center'>
                            <div className='border-bottom-tips-white'>
                                <button
                                    className={`${(tips === "free_tips") ? 'tips_btn_active f-mon-reg f-15' : 'tips_btn_non_active f-mon-reg f-15'}`}
                                    onClick={() => { TipsOption("free_tips") }}>FREE TIPS</button>
                                <button
                                    className={`${(tips === "premium_tips") ? 'tips_btn_active f-mon-reg f-15' : 'tips_btn_non_active f-mon-reg f-15'}`}
                                    onClick={() => { TipsOption("premium_tips") }}>PREMIUM TIPS</button>
                            </div>
                        </div>
                        {/* <div className='col-lg-4 mt-5'>
                            <div className='choose_category_pink'>
                                <p className='f-mon-bold f-20 catogry_tips'>
                                    CHOOSE CATEGORY
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list_active'>
                                    COLLEGE CATEGORY
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list'>
                                    COLLEGE BOWL
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list'>
                                    COLLEGE HOOPS
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list'>
                                    MARCH MADNESS
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list'>
                                    UFC YEARLY PACKAGE
                                </p>
                                <p className='f-mon-reg f-15 category_tips_list last_index'>
                                    WEEKEND PASS FRIDAY
                                </p>
                            </div>
                        </div> */}
                        <div className='col-lg-12 mt-5'>
                            <p className='f-mon-reg f-30 mb-0'>OUR AMAZING PROCESS</p>
                            <p className='f-mon-bold f-50 lh-01'>FIND THE <span className='clr-e0'>BEST TIPSTER</span></p>
                            <div className='brdr-btm-pink-tips_des'>

                            </div>
                            {/* {tipsData.tips.data.map(())} */}
                            {tipsData?.tips?.map((item, index) => {
                                // console.log("itemzzzzzzzzzzzz", item);
                                return (
                                    <div key={item.id} className='crd-tips-card mt-3 mb-5 mr-0'>
                                        {
                                            (item?.media)
                                                ?
                                                <>
                                                    {(item.media_url.slice(-3) === "mp4")
                                                        ?
                                                        <video width="100%" height="500" controls controlsList="nodownload" >
                                                            <source src={`${item.media_url}`} type="video/mp4" />
                                                        </video>
                                                        :
                                                        <div style={{ backgroundImage: `url("${item.media_url}")` }} className='crd-img-tip'>
                                                        </div>
                                                    }
                                                </>
                                                :
                                                <>
                                                    <div className='crd-img-tip bg-prdctndog-img'>
                                                    </div>
                                                </>
                                        }


                                        <div className='p-5 p-rezzz'>
                                            <p className='f-mon-bold f-30'>{item.title}</p>
                                            <p className='f-mon-light f-16 mb-4'>Posted On :

                                                {/* {item.updated_at.slice(0, 10)} */}

                                                <span className='ml-1'>{item.updated_at.slice(5, 7)}</span>
                                                <span>{item.updated_at.slice(7, 10)}</span>
                                                <span>-{item.updated_at.slice(0, 4)}</span>


                                                <span className='mx-3'>|</span>  <span>Posted by : {item.posted_by}</span></p>
                                            <div className='f-mon-light f-20 jabba' dangerouslySetInnerHTML={{ __html: item.description }}></div>
                                            <Link to={(item.is_premium === 0) ? `/tipsdetails/${item.id}/${item.is_premium}` : `/tipsdetails/${item.id}/${item.is_premium}`}>
                                                {/* <p className=' f-mon-reg f-16 read_more_tips mb-0'
                                                ></p> */}

                                                <button className='btn btn-light btn-rdmrr mt-5'>
                                                    Read More
                                                </button>
                                            </Link>

                                        </div>
                                    </div>
                                )
                            })}
                            <div className="col-lg-12 text-center">
                                {tipsData?.tips?.links?.map((item, index) => {
                                    if (item.label === "&laquo; Previous") {
                                        item.label = "Previous";
                                        return (
                                            <button key={index + 100}
                                                onClick={() => { TipsPagination(item.url) }}
                                                disabled={(item.url === null ? true : false)}
                                                className='btn btn-light bt-pagination-all'>
                                                {item.label}
                                            </button>
                                        )
                                    } else if (item.label === "Next &raquo;") {
                                        item.label = "Next";
                                        return (
                                            <button key={index + 100}
                                                onClick={() => { TipsPagination(item.url) }}
                                                disabled={(item.url === null ? true : false)}
                                                className='btn btn-light bt-pagination-all'>
                                                {item.label}
                                            </button>
                                        )
                                    } else {
                                        return (
                                            <button key={index + 100}
                                                onClick={() => { TipsPagination(item.url) }}
                                                disabled={(item.url === null ? true : false)}
                                                className='btn btn-light bt-pagination-all'>
                                                {item.label}
                                            </button>
                                        )
                                    }
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Tips;